import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Axios from '@/shared/api/axios';
import { getIdolArray } from '@/shared/store/slices/idolSlice';
import { setCurrentIdol } from '@/shared/store/slices/userSlice';

/**
 * 建立偶像後切換過去：重抓偶像列表 → switch-check → 設定目前偶像 → 導向編輯頁。
 * 傳入 /idol/create 的 response。用於「創建偶像」頁與偶像停權鎖定 modal。
 *
 * 回傳 status_code：成功為 SYSTEM_1000（已導頁）；失敗時不導頁，回傳失敗的狀態碼
 * （列表請求被 reject 時為攔截器附加的 httpErrorCode，含 NETWORK_ERROR），由呼叫端交給 StatusModal。
 * switch-check 的例外（HTTP 錯誤、逾時）直接拋出，由呼叫端的標準 catch 處理。
 */
export function useSwitchToCreatedIdol() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return async (createRes) => {
    const newIdolId = createRes.data.idol_id;
    const newIdolUuid = createRes.data.idol_uuid;

    const idolArrayResult = await dispatch(getIdolArray());
    if (getIdolArray.rejected.match(idolArrayResult)) {
      return idolArrayResult.payload;
    }
    // 與 idolSlice fulfilled 的判斷一致：data 不是陣列即視為失敗
    if (!Array.isArray(idolArrayResult.payload.data)) {
      return idolArrayResult.payload.status_code;
    }
    const newIdol = idolArrayResult.payload.data.find(i => i.idol_id === newIdolId);
    if (!newIdol) {
      // 建立成功但列表中找不到新偶像屬於後端資料異常，不做容錯，讓問題暴露（由呼叫端 catch 記 log）
      throw new Error(`Created idol ${newIdolId} not found in idol array`);
    }

    const switchRes = await Axios.post('/idol/switch-check', { idol_id: newIdolId });
    if (switchRes.data.status_code !== 'SYSTEM_1000') {
      return switchRes.data.status_code;
    }

    dispatch(setCurrentIdol(newIdol));
    navigate(`/idol-update/${newIdolUuid}`);
    return 'SYSTEM_1000';
  };
}
